module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-arrow-down-7b794bd8.svg";